import { useEffect, useRef, useState } from 'react'
import { parseMxnToCents } from '../lib/money.js'
function centsToText(c: number): string { return c ? (c / 100).toString() : '' }
interface MoneyInputProps { valueCents: number; onChangeCents: (cents: number) => void; placeholder?: string; disabled?: boolean; id?: string; ariaLabel?: string }
export default function MoneyInput({ valueCents, onChangeCents, placeholder = '0.00', disabled, id, ariaLabel }: MoneyInputProps) {
  const [text, setText] = useState(() => centsToText(valueCents))
  const focused = useRef(false)
  useEffect(() => { if (!focused.current) setText(centsToText(valueCents)) }, [valueCents])
  return (
    <input id={id} className="adm-input" type="text" inputMode="decimal" autoComplete="off"
      placeholder={placeholder} disabled={disabled} aria-label={ariaLabel} value={text}
      onFocus={() => { focused.current = true }}
      onChange={(e) => { const raw = e.target.value.replace(/[^\d.]/g, '').replace(/(\..*)\./g, '$1'); setText(raw); onChangeCents(raw === '' ? 0 : parseMxnToCents(raw)) }}
      onBlur={() => { focused.current = false; setText(centsToText(valueCents)) }} />
  )
}
